module.exports = __webpack_public_path__ + "static/media/hcm.69ed3c57.png";